import { c as _c } from "react/compiler-runtime";
import type { ComparisonTableColumn } from '@cc-shopping/contracts/credit-cards-page/reviews/schema/types';
import { EntityPlacementCtaTypeEnum } from '@cc-shopping/contracts/cross-site/marketplace/enums';
import { CTASearchParams } from '@cc-shopping/platform-analytics/lib/ctaSearchParams';
import { CdnImage, IMAGE_SIZES } from '@cc-shopping/ui/primitives/CdnImage';
import customImageWidthURLBuilder from '@cc-shopping/utils/custom-image-width-url-builder';
import { Box, Stack, Typography } from '@mui/material';
import { CtaLink } from 'src/features/product-card/CTA/CtaLink';
import { NerdWalletRating } from 'src/features/product-card/NerdWalletRating';
type CardAndRatingProps = {
  column: ComparisonTableColumn;
  shouldShowReviewLink?: boolean;
};
export default function CardAndRating(t0) {
  const $ = _c(43);
  const {
    column,
    shouldShowReviewLink
  } = t0;
  const {
    marketplaceEntity
  } = column;
  const {
    cta,
    ctaAnalytics,
    details: t1,
    displayName,
    finishType,
    image: t2,
    reviewLink,
    showNameInComparisonTable,
    starRating,
    starRatingTooltip
  } = marketplaceEntity;
  const {
    applyLink
  } = t1;
  const {
    resizable: resizableImage,
    small: smallImage
  } = t2;
  let t3;
  if ($[0] !== resizableImage || $[1] !== smallImage.url || $[2] !== smallImage.width) {
    t3 = customImageWidthURLBuilder(resizableImage, {
      customImageWidth: smallImage.width,
      customImageQuality: 100,
      imageParentWidth: 160
    }, smallImage.url);
    $[0] = resizableImage;
    $[1] = smallImage.url;
    $[2] = smallImage.width;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    optimized
  } = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      alignItems: "center",
      borderTop: 1,
      width: "100%",
      display: "flex",
      flexDirection: "column",
      pt: 3,
      pb: 1,
      borderColor: "neutral.light",
      textAlign: "center",
      justifyContent: "space-between",
      flex: 1
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = cta.type === EntityPlacementCtaTypeEnum.ApplyNow ? "nofollow" : undefined;
  const t6 = cta.type !== EntityPlacementCtaTypeEnum.ApplyNow;
  let t7;
  if ($[5] !== cta.type) {
    t7 = cta.type === EntityPlacementCtaTypeEnum.ApplyNow ? [CTASearchParams.MONETIZING, CTASearchParams.SHOPPING_FINISH] : [];
    $[5] = cta.type;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      alignItems: "center"
    };
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      width: "100%",
      display: "flex",
      justifyContent: "center"
    };
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      xs: "100px",
      md: "200px"
    };
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== optimized.parentElement.height || $[11] !== optimized.parentElement.width) {
    t11 = {
      position: "relative",
      width: optimized.parentElement.width,
      height: optimized.parentElement.height,
      maxHeight: "80px",
      maxWidth: t10
    };
    $[10] = optimized.parentElement.height;
    $[11] = optimized.parentElement.width;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  const t12 = displayName || "product-image";
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      objectFit: "contain",
      objectPosition: "center"
    };
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== optimized.image.url || $[15] !== t12) {
    t14 = <CdnImage src={optimized.image.url} alt={t12} fill={true} style={t13} sizes={IMAGE_SIZES.MINI_PRODUCT_CARD} />;
    $[14] = optimized.image.url;
    $[15] = t12;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== t11 || $[18] !== t14) {
    t15 = <Box sx={t9}><Box sx={t11}>{t14}</Box></Box>;
    $[17] = t11;
    $[18] = t14;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== displayName || $[21] !== showNameInComparisonTable) {
    t16 = displayName && showNameInComparisonTable && <Typography variant="textSmallBold" data-testid="comparison-table-product-name" sx={{
      mt: 1,
      px: 2,
      lineHeight: "1.25rem"
    }}>{displayName}</Typography>;
    $[20] = displayName;
    $[21] = showNameInComparisonTable;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== t15 || $[24] !== t16) {
    t17 = <Stack sx={t8}>{t15}{t16}</Stack>;
    $[23] = t15;
    $[24] = t16;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== applyLink || $[27] !== ctaAnalytics || $[28] !== finishType || $[29] !== t17 || $[30] !== t5 || $[31] !== t6 || $[32] !== t7) {
    t18 = <CtaLink analytics={ctaAnalytics} type="PRODUCT_IMAGE" href={applyLink} rel={t5} target="_blank" finishType={finishType} isReview={t6} parameterActions={t7}>{t17}</CtaLink>;
    $[26] = applyLink;
    $[27] = ctaAnalytics;
    $[28] = finishType;
    $[29] = t17;
    $[30] = t5;
    $[31] = t6;
    $[32] = t7;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== ctaAnalytics || $[35] !== reviewLink || $[36] !== shouldShowReviewLink || $[37] !== starRating || $[38] !== starRatingTooltip) {
    t19 = starRating ? <NerdWalletRating variant="reviews" ctaAnalytics={ctaAnalytics} starRating={starRating} reviewLink={shouldShowReviewLink ? reviewLink : null} starRatingTooltip={starRatingTooltip} containerProps={{
      "data-testid": "comparison-table-rating"
    }} textProps={{
      sx: {
        fontSize: {
          xs: "15px !important",
          md: "inherit !important"
        }
      }
    }} /> : null;
    $[34] = ctaAnalytics;
    $[35] = reviewLink;
    $[36] = shouldShowReviewLink;
    $[37] = starRating;
    $[38] = starRatingTooltip;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t18 || $[41] !== t19) {
    t20 = <Box sx={t4}>{t18}{t19}</Box>;
    $[40] = t18;
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  return t20;
}